import React from 'react';
import {
  AccessTime as AccessTimeIcon,
  AccountBalance as AccountBalanceIcon,
  Assessment as AssessmentIcon,
  BusinessCenter as BusinessCenterIcon,
  CalendarToday as CalendarTodayIcon,
  CurrencyExchange as CurrencyExchangeIcon,
  DateRange as DateRangeIcon,
  Event as EventIcon,
  GridView as GridViewIcon,
  Inventory as InventoryIcon,
  PieChart as PieChartIcon,
  RocketLaunch as RocketLaunchIcon,
  Schedule as ScheduleIcon,
  ShowChart as ShowChartIcon,
  TrendingUp as TrendingUpIcon,
  WatchLater as WatchLaterIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';

/**
 * ICON_MAPPER: Maps MUI icon component names to their respective React elements.
 */
const ICON_MAPPER: Record<string, React.ReactNode> = {
  GridViewIcon: <GridViewIcon sx={{ fontSize: '1.1rem' }} />,
  CalendarTodayIcon: <CalendarTodayIcon sx={{ fontSize: '1.1rem' }} />,
  DateRangeIcon: <DateRangeIcon sx={{ fontSize: '1.1rem' }} />,
  TrendingUpIcon: <TrendingUpIcon sx={{ fontSize: '1.1rem' }} />,
  ShowChartIcon: <ShowChartIcon sx={{ fontSize: '1.1rem' }} />,
  AccessTimeIcon: <AccessTimeIcon sx={{ fontSize: '1.1rem' }} />,
  ScheduleIcon: <ScheduleIcon sx={{ fontSize: '1.1rem' }} />,
  WatchLaterIcon: <WatchLaterIcon sx={{ fontSize: '1.1rem' }} />,
  EventIcon: <EventIcon sx={{ fontSize: '1.1rem' }} />,
  AssessmentIcon: <AssessmentIcon sx={{ fontSize: '1.1rem' }} />,
  BusinessCenterIcon: <BusinessCenterIcon sx={{ fontSize: '1.1rem' }} />,
  CurrencyExchangeIcon: <CurrencyExchangeIcon sx={{ fontSize: '1.1rem' }} />,
  PieChartIcon: <PieChartIcon sx={{ fontSize: '1.1rem' }} />,
  InventoryIcon: <InventoryIcon sx={{ fontSize: '1.1rem' }} />,
  RocketLaunchIcon: <RocketLaunchIcon sx={{ fontSize: '1.1rem' }} />,
  AccountBalanceIcon: <AccountBalanceIcon sx={{ fontSize: '1.1rem' }} />,
};

/**
 * getIconFromServerString: Parses the 'icon' string returned by the server.
 * Supports:
 * 1. MUI icon component strings: "<GridViewIcon ... />"
 * 2. Custom symbol strings: "<Box ...>₿</Box>"
 */
export const getIconFromServerString = (iconString?: string): React.ReactNode => {
  if (!iconString) return <GridViewIcon sx={{ fontSize: '1.1rem' }} />;

  // Case 1: Detect MUI Icon Component (e.g., <GridViewIcon sx={{...}} />)
  const muiMatch = iconString.match(/<(\w+Icon)/);
  if (muiMatch) {
    const iconName = muiMatch[1];
    return ICON_MAPPER[iconName] || <GridViewIcon sx={{ fontSize: '1.1rem' }} />;
  }

  // Case 2: Detect Custom Symbol inside <Box> or other tag (e.g., <Box ...>₿</Box>)
  const symbolMatch = iconString.match(/>([^<]+)</);
  if (symbolMatch) {
    const symbol = symbolMatch[1];
    return (
      <Box component="span" sx={{ fontSize: '1.1rem', fontWeight: 700 }}>
        {symbol}
      </Box>
    );
  }

  return <GridViewIcon sx={{ fontSize: '1.1rem' }} />;
};
